import QRCodeStyling from 'qr-code-styling';
import qhsLogo from '../../../../assets/icons/qlab_blue_logo.svg';

export const generateQRCode = (generatedLink, qrRef, logoLoaded, setQrCode) => {
  if (!qrRef.current || !logoLoaded) return;

  try {
    // Determine QR code size based on screen size
    const isMobile = window.matchMedia('(max-width: 600px)').matches;
    const isTablet = window.matchMedia('(max-width: 960px)').matches;
    const size = isMobile ? 150 : isTablet ? 200 : 270;

    const qr = new QRCodeStyling({
      width: size,
      height: size,
      type: 'canvas',
      data: generatedLink,
      margin: 15,
      qrOptions: {
        typeNumber: 3,
        mode: 'Byte',
        errorCorrectionLevel: 'M', // Lowest error correction = fewest dots
      },
      image: qhsLogo,
      dotsOptions: {
        color: '#5B65DC',
        type: 'dots', // Always use organic dots style
        size: 0.8, // Even larger dots
      },
      cornersSquareOptions: {
        type: 'extra-rounded',
        color: '#5B65DC',
        size: 0.35, // Much smaller corner squares (half of 0.7)
      },
      cornersDotOptions: {
        type: 'dot',
        color: '#5B65DC',
      },
      backgroundOptions: {
        color: '#FFFFFF',
      },
      imageOptions: {
        crossOrigin: 'anonymous',
        margin: 6,
        imageSize: .5,
      },
    });

    qrRef.current.innerHTML = '';
    qr.append(qrRef.current);
    setQrCode(qr);
  } catch (error) {
    console.error('Error generating QR code:', error);
    // Fallback: try generating without logo
    try {
      const size = isMobile ? 150 : isTablet ? 200 : 270;
      const qrFallback = new QRCodeStyling({
        width: size,
        height: size,
        type: 'canvas',
        data: generatedLink,
        margin: 15,
        qrOptions: {
          typeNumber: 3,
          mode: 'Byte',
          errorCorrectionLevel: 'M',
        },
        dotsOptions: {
          color: '#5B65DC',
          type: 'dots',
          size: 0.8,
        },
        cornersSquareOptions: {
          type: 'extra-rounded',
          color: '#5B65DC',
          size: 0.35,
        },
        cornersDotOptions: {
          type: 'dot',
          color: '#5B65DC',
        },
        backgroundOptions: {
          color: '#FFFFFF',
        },
      });
      qrRef.current.innerHTML = '';
      qrFallback.append(qrRef.current);
      setQrCode(qrFallback);
    } catch (fallbackError) {
      console.error('Failed to generate QR code even without logo:', fallbackError);
    }
  }
};
